import { render, staticRenderFns } from "./CustomFieldModalDeleteView.vue?vue&type=template&id=fa15527e"
import script from "./CustomFieldModalDeleteView.vue?vue&type=script&lang=ts"
export * from "./CustomFieldModalDeleteView.vue?vue&type=script&lang=ts"
import style0 from "./CustomFieldModalDeleteView.vue?vue&type=style&index=0&id=fa15527e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports